import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ArrowsClockwise } from "@phosphor-icons/react";

export default function FiltersBar({ value, onChange, showCreator = false, creators = [] }) {
  const [campaigns, setCampaigns] = useState([]);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    api.get("/analytics/campaigns").then((r) => setCampaigns(r.data)).catch(() => {});
  }, []);

  async function refreshMembers() {
    setRefreshing(true);
    try {
      const r = await api.post("/discord/membership/refresh");
      toast.success(`Refreshed ${r.data.checked} · +${r.data.new_joins} joins · -${r.data.new_leaves} leaves`);
      onChange({ ...value, __ping: Date.now() });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Discord bot not configured");
    } finally {
      setRefreshing(false);
    }
  }

  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value || null });

  return (
    <div className="card-tactical p-4 flex flex-wrap items-end gap-3">
      {showCreator && (
        <div>
          <div className="kbd-label mb-1">CREATOR</div>
          <select value={value.creator_id || ""} onChange={set("creator_id")} data-testid="filter-creator" className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm">
            <option value="">All creators</option>
            {creators.map((c) => <option key={c.id} value={c.id}>{c.display_name}</option>)}
          </select>
        </div>
      )}
      <div>
        <div className="kbd-label mb-1">CAMPAIGN</div>
        <select value={value.campaign || ""} onChange={set("campaign")} data-testid="filter-campaign" className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm">
          <option value="">All campaigns</option>
          {campaigns.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div>
        <div className="kbd-label mb-1">FROM</div>
        <input type="date" value={value.from_date || ""} onChange={set("from_date")} data-testid="filter-from-date" className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm" />
      </div>
      <div>
        <div className="kbd-label mb-1">TO</div>
        <input type="date" value={value.to_date || ""} onChange={set("to_date")} data-testid="filter-to-date" className="bg-black/60 border border-white/10 px-3 py-2 font-mono text-sm" />
      </div>
      <button onClick={() => onChange({})} data-testid="filter-clear" className="ghost-btn px-3 py-2 kbd-label text-white">CLEAR</button>
      <div className="flex-1" />
      <button onClick={refreshMembers} disabled={refreshing} data-testid="refresh-members" className="ghost-btn px-3 py-2 kbd-label text-white inline-flex items-center gap-2 disabled:opacity-50">
        <ArrowsClockwise size={14} className={refreshing ? "animate-spin" : ""} /> {refreshing ? "SYNCING…" : "SYNC MEMBERS"}
      </button>
    </div>
  );
}
